import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  IconButton,
  Menu,
  DialogActions,
  TextField,
  FormControl,
  Icon,
  Paper,
  Avatar,
  DialogTitle
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AlertDialog from "../../../components/AlertDialog";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import WarningDialog from "../../../components/WarningConfirm";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
// import Request from "../../components/home/Request";
// import { getMyRequestSuccess } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { getMyGoalDetail, deleteMyGoal, putUpdateProgress, getMyGoalProgress, getGoalFiles, deleteFileGoal, getFileDetail, putDeleteMyGoal, getGoalCycle } from "../../../actions/mygoal";
import { Link as RouterLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import React, { useEffect } from "react";
import cssVariables from "../../../theme/cssVariables";
import MessageDialog from "../../../components/inbox/MessageDialog";
import HistoryDialog from "../../../components/corporateGoal/HistoryDialog";
import { ReactComponent as ArrowRight } from "../../../icons/arrow-circle-right.svg";
import { ReactComponent as Trash } from "../../../icons/trash.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as CancelDelete } from "../../../icons/cancel-delete.svg";
import { ReactComponent as ScaleIcon } from "../../../icons/scale.svg";
import { ReactComponent as PersoncalIcon } from "../../../icons/personal.svg";
import { ReactComponent as TeamIcon } from "../../../icons/team.svg";
import { ReactComponent as CompIcon } from "../../../icons/comp.svg";
import { ReactComponent as PdfIcon } from "../../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../../assets/images/iconFile/Null-File.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { ReactComponent as KpiArrow } from "../../../assets/images/arrow-down.svg";
import { ReactComponent as History } from "../../../icons/history-2.svg";
import { ReactComponent as OrganizationChartIcon } from "../../../assets/icons/org-chart.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import * as Util from "../../../services/global.service";
import InputForm from "../../../components/achievement/InputForm";
import { postAchievementAdd, getKpiFormList } from "../../../actions/achievement";
import AttachFilesDialog from "../../../components/kpi/AttachFilesgoalDialog";
import { styled } from "@mui/styles";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { ReactComponent as TrashIcon } from "../../../assets/images/portfolio/trash-alt.svg";
import dayjs from 'dayjs'
import moment from 'moment'
import ClearIcon from "@mui/icons-material/Clear";

// import axios from "axios";

const MyGoalDetail = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const _ = require("lodash");
  let { serial } = useParams();
  const stateUser = useSelector(state => state.auth)

  // on click
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOption = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOption = (value, data) => {
    setAnchorEl(null);
    if (value === t('mygoal.label.delete') && data?.goal?.aproval_status !== 'pending_delete') {
      openConfirmDeleteDialog(true)
      setDeleteSerial(data.goal.serial)
    }
    if (value === t('mygoal.label.delete') && data?.goal?.aproval_status === 'pending_delete') {
      openCancelDeleteDialog(true)
      setDeleteSerial(data.goal.serial)
    }
    if (value === t('mygoal.label.edit')) {
      if (state.is_cascaded) {
        goto('mygoal-choose-type', state)
      } else {
        goto('mygoal-create/edit', state)
      }
    }
    if (value === t('mygoal.label.scaleLevelPick')) {
      openScaleDialog(true);
    }
  };
  const options = [
    t('mygoal.label.edit'),
    t('mygoal.label.scaleLevelPick'),
    t('mygoal.label.delete'),
  ];

  // dialog
  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false);
  const [isMemberDialogOpen, openMemberDialog] = React.useState(false);
  const [isAlignmentOpen, openAlignmentOpen] = React.useState(false);
  const [isScaleDialogOpen, openScaleDialog] = React.useState(false);
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false);
  const [isCancelDeleteDialogOpen, openCancelDeleteDialog] = React.useState(false);
  const [scaleLevelCurrent, setScaleLevelCurrent] = React.useState(null);
  const [menuList, setMenuList] = React.useState(options);

  const handleClearClick = () => {
    setTargetValue(null)
  }

  const handleCloseDialog = () => {
    openUpdateDialog(false);
    openMemberDialog(false);
    openScaleDialog(false);
    openAlignmentOpen(false);
  };

  const setDataForUpdateDialog = () => {
    setRemark("")
    openUpdateDialog(true);
    dispatch(getMyGoalDetail(serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if ((resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && resp?.data?.goal_progress?.actual_value !== '') {
          var splitValue = resp?.data?.goal_progress?.actual_value?.split('/')
          var target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          setTargetValue(target || null)
        } else {
          var date = null
          if (resp?.data?.goal_progress?.actual_value === '' && (resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
            date = dayjs().format('MM/DD/YYYY')
          } else {
            date = resp?.data?.goal_progress?.actual_value || null
          }
          setTargetValue(date)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setOwner(resp?.data?.is_owner)
        setLoadingData(false)
      })

    dispatch(getMyGoalProgress(serial))
      .then(resp => {
        if (resp.success) {
          setGoalProgressOption(resp.data.goal_progress_data)
          setHaveScaleData(resp.data.have_sacle)
          setGoalScaleData(resp.data.goal_scale)
          setScaleLevelCurrent(resp.data.goal_progress.scale_level_current)
          setTargetCondition(resp.data.goal_progress.target_condition)
          setLoadingData(false)
        }
      })
  }

  const updateGoal = () => {
    openUpdateDialog(false);
    // openSuccessAddDialog(true);
    // Do API here /goals/${id}/progress

    let target = targetValue;
    if (targetValue && targetValue.indexOf('/') > 0) {
      var splitValue = target.split('/')
      target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
    }

    const sendData = {
      serial: goalDetail?.goal?.serial,
      target_value: target,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }

    dispatch(putUpdateProgress(goalDetail?.goal?.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          dispatch(getMyGoalDetail(serial))
            .then(resp => {
              if (resp?.data?.log_goal_progress) {
                setHistoryData(resp.data.log_goal_progress)
              }
              if (resp?.data) {
                let tmp = {
                  goal_name: resp?.data?.goal?.name,
                  target_value: resp?.data?.goal_progress?.target_value,
                  target_condition: resp?.data?.goal?.target_condition,
                  type: resp?.data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
                }

                setGoalDetail(resp.data)
                setTargetValue(resp.data.goal_progress.actual_value)
                setHistoryOptionalData(tmp)
              }
            })
        }
        openSuccessAddDialog(true);
      })
  }


  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);

  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);

  const [isAlertDialogOpen, openAlertDialogOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [color, setColor] = React.useState("");
  const [colorHover, setColorHover] = React.useState("");
  const [size, setSize] = React.useState("");
  const [typeAlertDialog, setTypeAlertDialog] = React.useState("");
  const [errorText, seterrorText] = React.useState("");
  const [goalDetail, setGoalDetail] = React.useState({});
  const [fullVersion, setFullVersion] = React.useState(true);
  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})
  const [deleteSerial, setDeleteSerial] = React.useState(null);

  const [targetValue, setTargetValue] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(null);
  const [targetCondition, setTargetCondition] = React.useState(null);

  const [goalProgressOption, setGoalProgressOption] = React.useState([]);
  const [isOwner, setOwner] = React.useState(false);
  const [isMember, setIsMember] = React.useState(false)

  const [openFailedMessageDialogAlertDialog, setFailedMessageDialogAlertDialog] = React.useState(false);
  const [isSuccessDialogAlertDialog, setSuccessDialogAlertDialog] = React.useState(false);
  const [goalScaleData, setGoalScaleData] = React.useState([]);
  const [haveScaleData, setHaveScaleData] = React.useState(false);
  const [isAddDialogOpen, openDialog] = React.useState(false);
  const [formType, setFormType] = React.useState("");
  const [formData, setFormData] = React.useState({
    formEvaluateID: "",
    name: "",
    description: "",
    startDate: new Date(),
    endDate: Util.subStractDate(new Date(), "add", 1),
    metric: "",
    metricCondition: "",
    metricUnit: "",
    metricValue: "",
    isLink: false,
    selectedGoals: [],
    selectedCompetencies: [],
  });
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()));
  const [remark, setRemark] = React.useState("");
  const [openHistoryDialog, setHistoryDialog] = React.useState(false);
  const [historyData, setHistoryData] = React.useState([]);
  const [historyOptionalData, setHistoryOptionalData] = React.useState([]);
  const [formKpiSerial, setFormKpiSerial] = React.useState(null);
  const [attachCycle, setAttachCycle] = React.useState(null);
  const [hideData, setHideData] = React.useState([]);
  const [undeleteList, setUndeleteList] = React.useState([]);

  useEffect(() => {
    if (openHistoryDialog) {
      dispatch(getMyGoalDetail(serial))
        .then(resp => {
          if (resp?.data?.log_goal_progress) {
            setHistoryData(resp.data.log_goal_progress)
          }
          if (resp?.data) {
            let tmp = {
              goal_name: resp?.data?.goal?.name,
              target_value: resp?.data?.goal_progress?.target_value,
              target_condition: resp?.data?.goal?.target_condition,
              type: resp?.data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
            }
            setHistoryOptionalData(tmp)
          }
        })
    }
  }, [openHistoryDialog])

  const doGetMyGoalDetail = () => {
    dispatch(getMyGoalDetail(serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if (resp?.data?.log_goal_progress) {
          setHistoryData(resp.data.log_goal_progress)
        }
        if (resp?.data?.goal?.options !== null && resp?.data?.goal?.options?.cycle !== null) {
          setAttachCycle(resp?.data?.goal?.options?.cycle)
        }
        if (resp?.data) {
          let tmp = {
            goal_name: resp?.data?.goal?.name,
            target_value: resp?.data?.goal_progress?.target_value,
            target_condition: resp?.data?.goal?.target_condition,
            type: resp?.data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
          }
          setHistoryOptionalData(tmp)
        }
        if (resp?.data?.goal_progress?.goal_metric?.description === 'Date') {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        } else {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setOwner(resp?.data?.is_owner)
        setLoadingData(false)
      })
  }

  const handleHistoryDialog = (val) => {
    setHistoryDialog(val);
  }

  const onCloseAlertDialog = () => {
    setTitle("")
    setMessage("")
    setColor("")
    setTypeAlertDialog("")
    setColorHover("")
    setSize("")
    openAlertDialogOpen(false)
  }
  const [loadingData, setLoadingData] = React.useState(true)

  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };

  const handleCancelDeleteDialog = (val) => {
    openCancelDeleteDialog(val)
  };

  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };

  const handleConfirmDeleteList = () => {
    openConfirmDeleteDialog(false)
    dispatch(deleteMyGoal(deleteSerial))
      .then(resp => {
        if (resp.success) {
          openSuccessDeleteDialog(true);
        }
      })
  };

  const handleCancelDeleteList = async () => {
    openCancelDeleteDialog(false)
    // Delete API
    dispatch(putDeleteMyGoal(deleteSerial, { serial: deleteSerial }))
      .then(resp => {
        if (resp.success) {
          openSuccessCancelDeleteDialog(true)
          getGoalFilesList()
        }
      })
  };
  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
  }
  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }

  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state?.isEvaluator && state?.formEvaluateId) route += '/' + state.formEvaluateId
      route = '/' + route
    }

    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }

  const gotoDetail = (serial) => {
    if (serial != undefined)
      window.open(`/kpi/mygoal-detail/${serial}`, '_blank')
  }

  const handleGoTo = (val) => {
    navigate(`/kpi/achievement/${val}`, { replace: false });
  }

  const validateActualValueColor = (data) => {
    let result = false
    let targetCondition = ""
    if (historyOptionalData?.target_condition && historyOptionalData?.target_condition !== "") {
      targetCondition = historyOptionalData.target_condition.toLowerCase()
    }
    if (targetCondition !== "") {
      if (targetCondition === "equal") {
        if (parseFloat(historyOptionalData?.target_value) === parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher or equal to") {
        if (parseFloat(historyOptionalData?.target_value) <= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less or equal to") {
        if (parseFloat(historyOptionalData?.target_value) >= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher") {
        if (parseFloat(historyOptionalData?.target_value) < parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less") {
        if (parseFloat(historyOptionalData?.target_value) > parseFloat(data)) {
          result = true
        }
      }
    } else {
      if (historyOptionalData?.type === "accomplishment" || historyOptionalData?.type?.toLowerCase() === "ทำสำเร็จหรือไม่") {
        if (historyOptionalData?.target_value?.toLowerCase() === data?.toLowerCase()) {
          result = true
        }
        if (data?.toLowerCase() == 'fail') {
          result = false
        }
      } else if (historyOptionalData?.type === "date" || historyOptionalData?.type?.toLowerCase() === "ทำได้ภายใน End Date") {
        let targetValue = moment(String(historyOptionalData?.target_value), "DD-MM-YYYY")
        let actualValue = moment(String(data), "DD-MM-YYYY")
        let diff = targetValue.diff(actualValue, 'days')
        if (diff >= 0) {
          result = true
        }
      } else {
        if (historyOptionalData?.target_value >= data) {
          result = true
        }
      }
    }
    return result
  }

  const upperFirstWord = (str) => {
    if (str) {
      var splitStr = str.toString().toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }
  }

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete') {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }

  const goalTypeBox = (goalType) => {
    if (goalType?.seq === 3) {
      return (
        <Grid container style={{ backgroundColor: `${goalType?.options?.color ?? '#4085C9'}`, padding: '5px', paddingLeft: 3, paddingRight: 10, textAlign: 'center', borderRadius: '5px' }}>
          <Typography fontSize={15} lineHeight="21px" fontWeight="400" style={{ color: 'white' }}>
            {goalType?.options?.icon
              ?
              <Icon style={{ color: '#FFFFFF', fontSize: 22, marginRight: '5px', marginLeft: '5px', paddingTop: '3px' }}>{goalType?.options?.icon ?? 'settings'}</Icon>
              :
              <PersoncalIcon width={20} height={20} className={classes.internalIcon} style={{ paddingTop: 6 }} />
            }
          </Typography>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ color: 'white', paddingTop: '4px' }}>
            {goalType?.description}
          </Typography>
        </Grid>
      )
    } else if (goalType?.seq === 1) {
      return (
        <Grid container style={{ backgroundColor: `${goalType?.options?.color ?? '#FC9A3E'}`, padding: '5px', paddingLeft: 3, paddingRight: 10, textAlign: 'center', borderRadius: '5px' }}>
          <Typography fontSize={15} lineHeight="21px" fontWeight="400" style={{ color: 'white' }}>
            {goalType?.options?.icon
              ?
              <Icon style={{ color: '#FFFFFF', fontSize: 22, marginRight: '5px', marginLeft: '5px', paddingTop: '3px' }}>{goalType?.options?.icon}</Icon>
              :
              <CompIcon width={20} height={20} className={classes.internalIcon} style={{ paddingTop: 6 }} />
            }
          </Typography>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ color: 'white', paddingTop: '4px' }}>
            {goalType?.description}
          </Typography>
        </Grid>
      )
    } else if (goalType?.seq === 2) {
      return (
        <Grid container style={{ backgroundColor: `${goalType?.options?.color ?? '#BAD957'}`, padding: '5px', paddingLeft: 3, paddingRight: 10, textAlign: 'center', borderRadius: '5px' }}>
          <Typography fontSize={15} lineHeight="21px" fontWeight="600" style={{ color: 'white' }}>
            {goalType?.options?.icon
              ?
              <Icon style={{ color: '#FFFFFF', fontSize: 22, marginRight: '5px', marginLeft: '5px', paddingTop: '3px' }}>{goalType?.options.icon}</Icon>
              :
              <TeamIcon width={20} height={20} className={classes.internalIcon} style={{ paddingTop: 6 }} />
            }
          </Typography>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ color: 'white', paddingTop: '4px' }}>
            {goalType?.description}
          </Typography>
        </Grid>
      )
    }
  }

  const linkingLanguage = (linkingText) => {
    if (linkingText === null || !linkingText || linkingText === undefined) {
      return "-"
    } else if (linkingText.toString().toLowerCase().indexOf('parent') >= 0) {
      return t('mygoal.label.parentGoal')
    } else if (linkingText.toString().toLowerCase().indexOf('associate') >= 0) {
      return t('mygoal.label.associated')
    } else if (linkingText.toString().toLowerCase().indexOf('linking') >= 0) {
      return t('mygoal.label.linkingGoal')
    } else if (linkingText.toString().toLowerCase().indexOf('cascading') >= 0) {
      return t('mygoal.label.cascadingGoal')
    } else {
      return "-"
    }
  }

  // ----------------------------------
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    statusGraph: {
      "& > path": {
        fill: "#fff"
      }
    },
    internalIcon: {
      "& > path": {
        fill: "#fff"
      },
      '& g > path': {
        fill: '#fff'
      },
    },
    linkIcon: {
      "& > path": {
        fill: "#A0A0A0"
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
      cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const acceptConsent = (data, goalSerial) => {
    if (goalSerial) {
      navigate("/kpi" + data + "/" + goalSerial, { replace: false });
    } else {
      navigate("/kpi" + data, { replace: false });
    }
  }

  useEffect(() => {
    var mockupProgress = {
      code: "not_started",
      color: "{\"font\": \"#DADADA\", \"background\": \"#FFFFFF\"}",
      is_default: true,
      name: "Not Started",
      seq: 1,
      serial: "bfaeaf1f-f5ad-4ddb-b02d-624f05d16da0"
    }
    mockupProgress.color = JSON.parse(mockupProgress.color)
    setGoalProgressMockup(mockupProgress)
    dispatch(getMyGoalDetail(serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if (resp?.data?.log_goal_progress) {
          setHistoryData(resp.data.log_goal_progress)
        }
        if (resp?.data?.goal?.options !== null && resp?.data?.goal?.options?.cycle !== null) {
          setAttachCycle(resp?.data?.goal?.options?.cycle)
        }
        if (resp?.data) {
          let tmp = {
            goal_name: resp?.data?.goal?.name,
            target_value: resp?.data?.goal_progress?.target_value,
            target_condition: resp?.data?.goal?.target_condition,
            type: resp?.data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
          }
          setHistoryOptionalData(tmp)
        }
        if (resp?.data?.goal_progress?.goal_metric?.description === 'Date') {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        } else {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setOwner(resp?.data?.is_owner)
        setLoadingData(false)

        if (resp?.custom) {
          const customDataHide = resp?.custom?.data_hide?.configuration || []
          if (customDataHide) {
            let goals = _.filter(customDataHide, { module: 'goal' })
            let tmp = _.filter(goals, (o) => {
              let found = true
              if (o.category?.name) {
                found = (o.category?.name.toLowerCase() === resp.data?.goal?.goal_category?.name.toLowerCase())
              }

              return found
            })

            let fieldHideList = []
            for (const t of tmp) fieldHideList = [...fieldHideList, ...t.value]
            setHideData(fieldHideList)
          }


          const customUndelete = resp?.custom?.goal_undelete?.configuration || []
          if (customUndelete) {
            setUndeleteList(customUndelete)
          }

        }
      })

    dispatch(getMyGoalProgress(serial))
      .then(resp => {
        if (resp.success) {
          setGoalProgressOption(resp.data.goal_progress_data)
          setHaveScaleData(resp.data.have_sacle)
          setGoalScaleData(resp.data.goal_scale)
          setTargetCondition(resp.data.goal_progress.target_condition)
          setLoadingData(false)
        }
      })
    getGoalFilesList()
  }, [serial])

  useEffect(() => {
    if (state) {
      if (state?.historyTemplate) {
        dispatch(getGoalCycle())
          .then(resp => {
            if (resp.data.length > 0) {
              const kpiFormSerial = resp.data.find((item) => item.options.serial === state.historyTemplate).value
              setFormKpiSerial(kpiFormSerial)
            }
          })
      }
    }
  }, [state])



  const totalMember = (goalDetail) => {
    var total = 0;
    if (goalDetail.goal_member?.members?.length > 0) {
      total = goalDetail.goal_member?.members?.length
    }
    if (goalDetail.goal_member?.owner != null) {
      total += 1
    }

    return total;
  }

  const totalAlignment = (goalDetail) => {
    var total = 0;
    if (goalDetail.goal_alignment?.members?.length > 0) {
      total = goalDetail.goal_alignment?.members?.length
    }

    return total;
  }

  const handleOpenDialog = (value) => {
    setFormType(value)
    openDialog(true);
  };

  const handlePreSelectForm = () => {
    let formatResp = {
      achievementSerial: "",
      name: "",
      description: "",
      startDate: new Date(),
      endDate: Util.subStractDate(new Date(), "add", 1),
      metric: "",
      metricCondition: "",
      metricUnit: "",
      metricUnitCustom: "",
      metricValue: "",
      isLink: true,
      selectedGoals: Util.formatData(goalDetail?.goal?.serial, false) !== false ? [goalDetail?.goal?.serial] : [],
      selectedCompetencies: [],
    }
    handleOpenDialog("edit")
    setFormData(formatResp)
  }
  const backdropClick = (event) => {
    return false
  }

  const handleSubmitForm = (value) => {
    const values = Object.assign(value, { cycle: attachCycle })
    dispatch(postAchievementAdd(values)).then((resp) => {
      openDialog(false)
      handleSuccessDialog()
      dispatch(getMyGoalDetail(serial))
        .then(resp => {
          setGoalDetail(resp.data)
          setTargetValue(resp.data.goal_progress.target_value)
        })
    }).catch(() => {
      openDialog(false)
      seterrorText(t("label.pleaseTryAgain"));
      handleOpenFailedMessageDialogAlertDialog(true);
    })
  };
  const handleSuccessDialog = () => {
    setSuccessDialogAlertDialog(true);
    handleCloseDialog();
  };
  const handleOpenFailedMessageDialogAlertDialog = (value) => {
    setFailedMessageDialogAlertDialog(true);
  };
  const handleCloseFailedMessageDialogAlertDialog = (value) => {
    setFailedMessageDialogAlertDialog(false);
  };
  const [discardDialogAlertDialog, setDiscardDialogAlertDialog] = React.useState(false);
  const handleDiscardDialog = (value) => {
    setDiscardDialogAlertDialog(value)
  };
  const compareInputForm = (oldVal, newVal) => {
    const checkEveryElement = (a, b) => {
      return a.every((v, i) => v === b[i]);
    }
    let isEqual = true
    if (oldVal.description !== newVal.description) isEqual = false
    if (Util.formatDate(oldVal.endDate) !== newVal.endDate) isEqual = false
    if (Util.formatDate(oldVal.startDate) !== newVal.startDate) isEqual = false
    if (oldVal.isLink !== newVal.isLink) isEqual = false
    if (oldVal.metric !== newVal.metric) isEqual = false
    if (oldVal.metricCondition !== newVal.metricCondition) isEqual = false
    if (oldVal.metricUnit !== newVal.metricUnit) isEqual = false
    if (oldVal.metricValue !== newVal.metricValue) isEqual = false
    if (oldVal.name !== newVal.name) isEqual = false
    if (oldVal.selectedGoals.length !== newVal.selectedGoals.length && !checkEveryElement(oldVal.selectedGoals, newVal.selectedGoals)) {
      isEqual = false
    }
    if (oldVal.selectedCompetencies.length !== newVal.selectedCompetencies.length && !checkEveryElement(oldVal.selectedCompetencies, newVal.selectedCompetencies)) {
      isEqual = false
    }
    return isEqual
  }
  const handleDiscardChangeConfirmAlertDialog = () => {
    handleDiscardDialog(false)
    openDialog(false);
    setFormData({
      formEvaluateID: "",
      name: "",
      description: "",
      startDate: new Date(),
      endDate: Util.subStractDate(new Date(), "add", 1),
      metric: "",
      metricCondition: "",
      metricUnit: "",
      metricValue: "",
      isLink: false,
      selectedGoals: [],
      selectedCompetencies: [],
    });
  };
  const handleCloseDialogAlertDialog = (values = null) => {
    if (values) {
      let isFormEqual = compareInputForm({ ...formData }, values)
      if (isFormEqual) {
        openDialog(false);
        setFormData({
          formEvaluateID: "",
          name: "",
          description: "",
          startDate: new Date(),
          endDate: Util.subStractDate(new Date(), "add", 1),
          metric: "",
          metricCondition: "",
          metricUnit: "",
          metricValue: "",
          isLink: false,
          selectedGoals: [],
          selectedCompetencies: [],
        });
      } else {
        handleDiscardDialog(true)
      }
    } else {
      openDialog(false);
      setFormData({
        formEvaluateID: "",
        name: "",
        description: "",
        startDate: new Date(),
        endDate: Util.subStractDate(new Date(), "add", 1),
        metric: "",
        metricCondition: "",
        metricUnit: "",
        metricValue: "",
        isLink: false,
        selectedGoals: [],
        selectedCompetencies: [],
      });
    }

  };
  const [isAttachFilesDialogOpen, openAttachFilesDialog] = React.useState(false);

  const handleFilesDialog = (value) => {
    openAttachFilesDialog(value)
  }
  const [fileList, setFileList] = React.useState([]);
  const [isSuccessAttachFiles, setIsSuccessAttachFiles] = React.useState(false);

  const [successAttachmentsText, setSuccessAttachmentsText] = React.useState("")
  const uploadAttachmentsSuccess = () => {
    setSuccessAttachmentsText(t("label.uploadSuccessText"))
    setIsSuccessAttachFiles(true)
    getGoalFilesList()
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
      // maxWidth: 300,
    },
  }));

  const getGoalFilesList = () => {
    dispatch(getMyGoalDetail(serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if (resp?.data?.goal_progress?.goal_metric?.description === 'Date') {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        } else {
          setTargetValue(resp?.data?.goal_progress?.actual_value || null)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setLoadingData(false)
        if (resp.length > 0) {
          resp.sort(function (a, b) {
            const date1 = new Date(a.created_at)
            const date2 = new Date(b.created_at)
            return date1 - date2;
          })
          setFileList(resp?.data?.goal_file)
        }

        // API GET ERROR WAITING FOR RERUN TEST
        dispatch(getMyGoalProgress(serial))
          .then(resp => {
            if (resp.success)
              setGoalProgressOption(resp.data.goal_progress_data)
            setLoadingData(false)
          })
      })
  }
  const [isSuccessDeleteFileDialogOpen, openSuccessDeleteFileDialog] = React.useState(false);
  const [isConfirmDeleteFileDialogOpen, openConfirmDeleteFileDialog] = React.useState(false);
  const [isSuccessCancelDeleteDialogOpen, openSuccessCancelDeleteDialog] = React.useState(false);
  const [fileSerial, setFileSerial] = React.useState("");

  const handleConfirmDeleteFileDialog = (val, serial = "") => {
    openConfirmDeleteFileDialog(val)
    if (serial !== "") setFileSerial(serial)
  }

  const handleConfirmDeleteAchievementFile = () => {
    if (fileSerial !== "") {
      dispatch(deleteFileGoal(fileSerial)).then(() => {
        getGoalFilesList()
        openSuccessDeleteFileDialog(true)
      }).catch(() => {
        getGoalFilesList()
      })
    } else {
      setFailedMessageDialog(true);
    }
    handleConfirmDeleteFileDialog(false)
  }

  const handleSuccessDeleteFileDialog = (val) => {
    openSuccessDeleteFileDialog(val)
  }
  const openFileInNewTab = (val) => {
    console.log(val, 744);
    dispatch(getGoalFiles(val.serial)).then((resp) => {
      const newWindow = window.open(resp.data, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    })
  }

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  function niceBytes(x) {
    let l = 0, n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }

  const handleViewGoalChart = () => {
    window.open(`/kpi/mygoal-detail/${serial}/chart`, '_blank')
  }



  const getTitle = () => {
    let title = t('mygoal.page.mygoal')

    if (state?.isEvaluator && state?.owner?.firstname) {
      title = state.owner.firstname + ' ' + state.owner.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  // useEffect
  useEffect(() => {
    let result = false
    if (stateUser?.user?.profile?.employee && stateUser?.user?.profile?.employee !== "") {
      result = goalDetail?.goal_member?.members?.find(member => member?.serial === stateUser.user.profile.employee)
      result = result ? true : false
    }
    setIsMember(result)
  }, [stateUser, goalDetail])

  useEffect(() => {
    if (goalDetail?.goal?.serial) {

      if ((goalDetail?.goal?.is_owner && goalDetail?.goal?.goal_type?.code === 'team') || goalDetail?.goal?.goal_type?.code !== 'team') {

      } else {
        let menuList = [
          t('mygoal.label.scaleLevelPick'),
        ]

        setMenuList(menuList)
      }

    }
  }, [goalDetail])

  return (
    <>
      <Helmet>
        <title>{getTitle()} | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => acceptConsent('/home')}>
                {t('label.home')}
              </span> / &nbsp;
              <span style={styles.link} onClick={() => goto(`mygoal${state.viewSerial ? '/' + state.viewSerial : ''}`, state)}>
                {getTitle()}
              </span> / &nbsp;
              <span style={styles.end} >
                {t('mygoal.label.goalDetail')}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          {loadingData === false &&
            <Grid container >
              <Grid item md={9}>
                <Grid container direction="row">
                  <Grid item mr={1} style={{ maxWidth: '80%' }}>
                    <Typography fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                      {`${goalDetail.goal?.name}`}
                    </Typography>
                  </Grid>
                  {/* <Grid item sx={{paddingLeft: '35px'}}>
                    {goalTypeBox(goalDetail?.goal?.goal_type)}
                  </Grid> */}
                </Grid>
              </Grid>
              {(isOwner || state?.isGoalOwner) ?
                <Grid item ml="auto" textAlign="right">
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => { setDataForUpdateDialog() }}
                    color="primary"
                    variant="contained"
                    disabled={(state?.statusForm?.name !== 'approved' || goalDetail.is_owner === false) || (goalDetail?.goal?.goal_type?.seq == '1' && goalDetail?.goal_member?.is_owner === false)}
                    style={{ textTransform: 'none', paddingLeft: '8px', paddingRight: '8px', marginRight: '15px' }}
                  >
                    <Icon style={{ color: 'white', fontSize: 25 }}>{'rotate_left'}</Icon>
                    <Typography ml={1} style={{ color: fullVersion ? '#FFF' : '#F7F7F7' }} fontSize={16} fontWeight={500}>
                      {t('mygoal.label.update')}
                    </Typography>
                  </Button>
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openOption ? 'long-menu' : undefined}
                    aria-expanded={openOption ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    sx={{
                      borderRadius: '5px', border: '1px solid #E5E5E5', paddingLeft: '1px', paddingRight: '1px', paddingTop: '6px', paddingBottom: '6px',
                      "&:hover": {
                        backgroundColor: "#EFF6F4"
                      }
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={openOption}
                    onClose={handleOption}
                    PaperProps={{
                      style: {
                        maxHeight: 48 * 4.5,
                        width: '20ch',
                      },
                    }}
                  >
                    {menuList.map((option) => (
                      <MenuItem key={option} onClick={() => handleOption(option, goalDetail)} disabled={
                        (option === t('mygoal.label.scaleLevelPick') && (goalScaleData.length === 0 || haveScaleData === false))
                        || (option === t('mygoal.label.delete') && state?.is_owner === false)
                        || (option === t('mygoal.label.edit') && goalDetail?.goal?.aproval_status === 'pending_delete')
                        || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && state?.workflowEnd)
                        || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !state?.isCreatable)
                        || ((option == t('mygoal.label.delete')) && undeleteList.indexOf('is_approved') !== -1 && goalDetail.is_approved)
                        //|| ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !state?.isCreatable)
                      } sx={{ color: (option === t('mygoal.label.delete') && goalDetail?.goal?.aproval_status === 'pending_delete') ? '#CC6058' : "#404349" }}>
                        {
                          option == t('mygoal.label.scaleLevelPick') ?
                            <ScaleIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                            : option == t('mygoal.label.edit') ?
                              <EditIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                              : option === t('mygoal.label.delete') &&
                                goalDetail?.goal?.aproval_status === 'pending_delete' ?
                                <CancelDelete style={{ marginTop: '5px', marginRight: '5px' }} />
                                : <DeleteIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                        }
                        {(option === t('mygoal.label.delete') && goalDetail?.goal?.aproval_status === 'pending_delete') ? t('mygoal.label.cancelDeleteBtn') : option}
                      </MenuItem>
                    ))}
                  </Menu>
                </Grid>
                :
                <Grid item ml="auto" textAlign="right">
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openOption ? 'long-menu' : undefined}
                    aria-expanded={openOption ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    sx={{
                      borderRadius: '5px', border: '1px solid #E5E5E5', paddingLeft: '1px', paddingRight: '1px', paddingTop: '6px', paddingBottom: '6px',
                      "&:hover": {
                        backgroundColor: "#EFF6F4"
                      }
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={openOption}
                    onClose={handleOption}
                    PaperProps={{
                      style: {
                        maxHeight: 48 * 4.5,
                        width: '20ch',
                      },
                    }}
                  >
                    {options.map((option) => (
                      option == t('mygoal.label.scaleLevelPick') &&
                      <MenuItem key={option} onClick={() => handleOption(option, goalDetail)} disabled={((option === t('mygoal.label.scaleLevelPick') && goalScaleData.length === 0))}>
                        {
                          option == t('mygoal.label.scaleLevelPick') &&
                          <ScaleIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                        }
                        {(option === t('mygoal.label.delete') && goalDetail?.goal?.aproval_status === 'pending_delete') ? t('mygoal.label.cancelDeleteBtn') : option}
                      </MenuItem>
                    ))}

                  </Menu>
                </Grid>
              }
              <Grid item md={12} pr={1} mt={3} mb={2}>
                <Typography color="#404349">
                  {`${goalDetail.goal?.description}`}
                </Typography>
              </Grid>
            </Grid>
          }
          {loadingData === false
            ?
            <Grid container spacing={4}>
              <Grid lg={6} xs={12} item>
                <Card style={{ height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                        direction="row"
                        justifyContent={"space-between"}
                      >
                        <Grid item style={{ height: '30px' }}>
                          <Typography fontSize={20} lineHeight="21px" fontWeight="500" color="#404349">
                            {t('mygoal.label.goalDetail')}
                          </Typography>
                        </Grid>
                        <Grid item style={{ paddingLeft: '15px', paddingBottom: '8px' }}>
                          {goalTypeBox(goalDetail?.goal?.goal_type)}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    <Grid container lg={12} xs={12} mb={3} ml={1}>
                      <Grid item lg={5} xs={12} mb={2} mt={2} style={{ alignSelf: 'center' }}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.goalCategory')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2} mt={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.goal_category?.name || '-'}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }} color="#404349">
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                          {t('mygoal.label.goalGroup')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.goal_group || '-'}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }} color="#404349">
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                          {t('mygoal.label.goalSubGroup')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.goal_sub_group || '-'}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }} color="#404349">
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                          {t('mygoal.label.evaluationWeight')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.weight}%
                        </Typography>
                      </Grid>
                      {/* <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }} color="#404349">
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                          {t('mygoal.label.approvalDate')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.approve_date || '-'}
                        </Typography>
                      </Grid> */}
                      <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }} color="#404349">
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                          {t('mygoal.label.approvalStatus')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {statusBox(goalDetail.goal?.aproval_status)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Card style={{ height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                      >
                        <Grid item display="flex" alignItems="center" justifyContent="center" mt="10px" mb="10px">
                          <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                            {t('mygoal.label.goalProgress')}
                          </Typography>
                        </Grid>
                        <Grid item ml="auto">
                          <Button onClick={() => handleHistoryDialog(true)} color="primary" variant="text">
                            <History />
                            <Typography ml={1} sx={{ textTransform: "none" }}>{t("corporateGoal.label.history")}</Typography>
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    <Grid container lg={12} xs={12} mb={3} ml={1}>
                      <Grid item lg={5} xs={12} mb={2} mt={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.startEndDate').replace(':', '')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2} mt={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal_progress?.start_date} - {goalDetail.goal_progress?.end_date}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.measurement')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal?.measurement || '-'}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.goalMetric').replace(':', '')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal_progress?.goal_metric?.description}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.targetValue').replace(':', '')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {Util.upperFirstWord(targetCondition ?? '')} {goalDetail.goal_progress?.goal_metric?.type === "Date" ? goalDetail.goal_progress?.target_value === 'Success' ? t('mygoal.popup.success') : goalDetail.goal_progress?.actual_value || '-' : goalDetail.goal_progress?.target_value || '-'}
                        </Typography>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.valueUnit')}
                        </Typography>
                      </Grid>

                      <Grid item lg={7} xs={12} mb={2}>
                        <Typography fontSize={18} color="#939393" fontWeight='400'>
                          {goalDetail.goal_progress?.unit || '-'}
                        </Typography>
                      </Grid>

                      {hideData.indexOf('actual_value') === -1 &&
                        <>
                          <Grid item lg={5} xs={12} mb={2}>
                            <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                              {t('mygoal.label.labelActualValue')}
                            </Typography>
                          </Grid>
                          <Grid item lg={7} xs={12} mb={2} display="flex" flexDirection="column">
                            <Typography fontWeight="400" fontSize={18} variant="label" color={goalDetail.goal_progress?.actual_value ? validateActualValueColor(historyData.length > 0 ? historyData[0]?.actual_value : '-') ? "#5DA196" : "#CC6058" : "#828282"}>
                              {historyData.length > 0 ? historyData[0]?.actual_value : '-'}
                            </Typography>
                            <Typography fontSize={14} fontWeight="400" variant="label">
                              {`( `} {t('corporateGoal.label.resultAsOf')}: {historyData.length > 0 ? historyData[0]?.date ? Util.dateDayFormatAdmin(historyData[0].date) : "-" : "-"} {` )`}
                            </Typography>
                          </Grid>
                        </>
                      }



                      {hideData.indexOf('goal_progress') === -1 &&
                        <>
                          <Grid item lg={5} xs={12} mb={2} pt={'12px'}>
                            <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                              {t('mygoal.label.goalProgress')}
                            </Typography>
                          </Grid>
                          <Grid item lg={7} xs={12} mb={2}>
                            <Typography fontSize={18} color="#939393" fontWeight='400'>
                              {
                                (goalDetail?.goal_progress?.goal_progress_data && Object.keys(goalDetail?.goal_progress?.goal_progress_data).length > 0) &&
                                statusBox(goalDetail?.goal_progress?.goal_progress_data)
                              }
                            </Typography>
                          </Grid>
                        </>
                      }

                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              {(goalDetail?.goal?.more_detail !== undefined && goalDetail?.goal?.more_detail !== null) &&
                <Grid lg={12} xs={12} item>
                  <Card style={{ height: '100%' }}>
                    <CardContent>
                      <Grid item lg={12} xs={12} container>
                        <Grid
                          item
                          lg={12}
                          xs={12}
                          display="flex"
                        >
                          <Grid item display="flex" alignItems="center" justifyContent="center" mt="10px" mb="10px">
                            <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                              {t('mygoal.label.moreDetail')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                      {/* ### Waiting for API for loop Data */}

                      {goalDetail?.goal?.more_detail?.map((item) => {
                        return <>
                          <Grid container lg={12} xs={12}>
                            <Grid item lg={2.4} xs={12} mt={'15px'} ml={1}>
                              <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                                {item.label}
                              </Typography>
                            </Grid>
                            <Grid item lg={8} xs={12} mt={'15px'}>
                              <Typography fontSize={18} color="#939393" fontWeight='400'>
                                {(item.type === 'dropdown' && item.value !== '')
                                  ? (i18n.language === "th-TH") ? item?.options?.data?.find((data) => data.id === item.value).label?.th : item?.options?.data?.find((data) => data.id === item.value).label?.en
                                  : Util.capitalizedString(item.value || '-') || '-'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      })}
                    </CardContent>
                  </Card>
                </Grid>
              }
              <Grid lg={6} xs={12} item>
                <Card style={{ height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                        pb={isOwner ? '7px' : '0px'}
                      >
                        <Grid md={9} item style={{ height: '30px', marginBottom: '4px', paddingTop: '7px' }}>
                          <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                            {t('mygoal.label.goalAlignment')}
                          </Typography>
                        </Grid>
                        <Grid md="auto" item textAlign="right" sx={{ pt: '5px' }}>
                          {(goalDetail?.goal_alignment?.alignment.toLowerCase() === 'cascading' && goalDetail.goal_alignment?.members?.length > 0) &&
                            <>
                              <Typography onClick={() => openAlignmentOpen(true)} fontSize={14} lineHeight="21px" fontWeight="400" variant="label" color="#5DA196" textAlign="right" style={{ cursor: 'pointer' }}>
                                {t('mygoal.label.moreDetail')}
                              </Typography>
                            </>
                          }
                          {true &&
                            //(process.env.REACT_APP_MODE !== "uat" && process.env.REACT_APP_MODE !== "staging" && process.env.REACT_APP_MODE !== "production") &&
                            <Button
                              size="small"
                              aria-controls="simple-menu"
                              aria-haspopup="true"
                              onClick={() => handleViewGoalChart()}
                              variant="outlined"
                              color="black"
                              sx={{ p: 0, textTransform: 'none', width: "162px", height: "34px", ml: 2 }}
                              disabled={!fullVersion}
                            >
                              <OrganizationChartIcon sx={{ width: "20px", height: "17.5px" }} />
                              <Typography ml={1} color="#404349" fontSize={16} fontWeight={600}>
                                {t('label.viewGoalChart')}
                              </Typography>
                            </Button>
                          }
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    {goalDetail?.goal_alignment?.alignment.toLowerCase() !== 'cascading'
                      ?
                      <Grid container lg={12} xs={12} mb={3} ml={1}>
                        <Grid item lg={5} xs={12} mb={2} mt={2} style={{ alignSelf: 'center' }}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                            {t('mygoal.label.alignmentType')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2} mt={2}>
                          <Typography fontSize={18} color="#939393" fontWeight='400'>
                            {linkingLanguage(goalDetail.goal_alignment?.alignment)}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                            {t('mygoal.label.linkingType')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontSize={18} color="#939393" fontWeight='400'>
                            {linkingLanguage(goalDetail.goal_alignment?.alignment_type)}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                            {t('mygoal.label.linkedGoal')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Box style={{ border: '1px solid #DCDCDC', padding: 11, paddingLeft: 16, marginRight: 10, borderRadius: 5 }}>
                            <Grid container direction="row">
                              <Grid item lg={10}>
                                <Grid container direction="row">
                                  <Grid item lg={1} style={{ alignSelf: 'center' }}>
                                    <Icon style={{ color: '#74C1ED' }}>{goalDetail.goal_alignment?.linked?.parent_goal?.goal_category?.icon ?? goalDetail.goal_alignment?.linked?.goal?.goal_category?.icon}</Icon>
                                  </Grid>
                                  <Grid item lg={11} pt={'2px'} pl={'5px'}>
                                    <BootstrapTooltip
                                      placement="right"
                                      arrow
                                      title={goalDetail.goal_alignment?.linked?.parent_goal?.name ?? goalDetail.goal_alignment?.linked?.goal?.name ?? '-'}
                                      style={{ marginLeft: '5px' }}
                                    >
                                      <Typography fontSize={16} lineHeight="21px" fontWeight="400" color="#404349"
                                        sx={{
                                          display: '-webkit-box',
                                          overflow: 'hidden',
                                          WebkitBoxOrient: 'vertical',
                                          WebkitLineClamp: 2
                                        }}
                                      >
                                        {goalDetail.goal_alignment?.linked?.parent_goal?.name ?? goalDetail.goal_alignment?.linked?.goal?.name ?? '-'}
                                      </Typography>
                                    </BootstrapTooltip>
                                  </Grid>
                                </Grid>
                              </Grid>
                              {(goalDetail.goal_alignment?.linked?.parent_goal?.serial || goalDetail.goal_alignment?.linked?.goal?.name) &&
                                <Grid item lg={2} style={{ textAlign: 'right', alignSelf: 'center' }}>
                                  <Box sx={{ marginLeft: "auto", background: "#F5F5F5", borderRadius: "3px", p: "2px", width: "25px", height: "25px" }}>
                                    <KpiArrow onClick={() => { gotoDetail(goalDetail.goal_alignment?.linked?.parent_goal?.serial ?? goalDetail.goal_alignment?.linked?.goal?.serial) }} style={{ cursor: "pointer" }} />
                                  </Box>
                                </Grid>
                              }
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                      :
                      <Grid container lg={12} xs={12} mb={2.5} ml={1}>
                        {goalDetail?.goal_alignment?.linked?.parent_goal && (
                          <>
                            <Grid item lg={5} xs={12} mb={2} style={{ alignSelf: 'center' }}>
                              <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                                {t('mygoal.label.parentGoal')}
                              </Typography>
                            </Grid>
                            <Grid item lg={7} xs={12} mb={2.5}>
                              <Box style={{ border: '1px solid #DCDCDC', padding: 11, paddingLeft: 16, marginRight: 10, borderRadius: 5 }}>
                                <Grid container direction="row">
                                  <Grid item lg={10}>
                                    <Grid container direction="row">
                                      <Grid item lg={1}>
                                        {goalDetail.goal_alignment?.linked?.parent_goal?.goal_category?.icon
                                          ?
                                          <Icon style={{ color: '#74C1ED' }}>{goalDetail.goal_alignment?.linked?.parent_goal?.goal_category?.icon}</Icon>
                                          :
                                          <Icon style={{ color: '#74C1ED' }}>{'settings'}</Icon>
                                        }
                                      </Grid>
                                      <Grid item lg={11} pt={'2px'} pl={'5px'}>
                                        <BootstrapTooltip
                                          placement="right"
                                          arrow
                                          title={goalDetail.goal_alignment?.linked?.parent_goal?.name ?? '-'}
                                          style={{ marginLeft: '5px' }}
                                        >
                                          <Typography fontSize={16} lineHeight="21px" fontWeight="400" color="#404349"
                                            sx={{
                                              display: '-webkit-box',
                                              overflow: 'hidden',
                                              WebkitBoxOrient: 'vertical',
                                              WebkitLineClamp: 2
                                            }}
                                          >
                                            {goalDetail.goal_alignment?.linked?.parent_goal?.name ?? '-'}
                                          </Typography>
                                        </BootstrapTooltip>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {goalDetail.goal_alignment?.linked?.parent_goal?.serial &&
                                    <Grid item lg={2} style={{ textAlign: 'right' }}>
                                      <Box sx={{ marginLeft: "auto", background: "#F5F5F5", borderRadius: "3px", p: "2px", width: "25px", height: "25px" }}>
                                        <KpiArrow onClick={() => { gotoDetail(goalDetail.goal_alignment?.linked?.parent_goal?.serial) }} style={{ cursor: "pointer" }} />
                                      </Box>
                                    </Grid>
                                  }
                                </Grid>
                              </Box>
                            </Grid>
                          </>
                        )}
                        <Grid item lg={5} xs={12} mb={2} mt={!goalDetail?.is_owner ? 0 : 2} style={{ alignSelf: 'center' }}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                            {t('mygoal.label.alignmentType')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2} mt={!goalDetail?.is_owner ? 0 : 2}>
                          <Typography fontSize={18} color="#939393" fontWeight='400'>
                            {linkingLanguage(goalDetail.goal_alignment?.alignment)}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2} mt={2.5}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                            {t('mygoal.label.assignMembers')}
                          </Typography>
                        </Grid>
                        {goalDetail.goal_alignment?.members?.length > 0
                          ? <Grid item lg={7} xs={12} mb={2} mt={2}>
                            <Grid container direction="row">
                              <Grid item>
                                <Avatar
                                  src={goalDetail.goal_alignment?.members[0]?.photo}
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    marginRight: '10px'
                                  }}
                                >
                                </Avatar>
                              </Grid>
                              <Grid item>
                                <Typography fontWeight="400" fontSize={18} color="#939393">
                                  {goalDetail.goal_alignment?.members[0]?.fullname}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          : <Typography style={{ fontSize: 18, fontWeight: 400, color: "#939393" }} mt={2} >-</Typography>
                        }
                      </Grid>
                    }
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Card style={{ height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Grid item lg={10} style={{ height: '30px' }}>
                          <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                            {t('mygoal.label.achievement')} ({goalDetail.achievement?.length})
                          </Typography>
                        </Grid>
                        {(isOwner || isMember) &&
                          <Grid item lg={2} textAlign="right" pb={'7px'}>
                            <Button
                              size="small"
                              aria-controls="simple-menu"
                              aria-haspopup="true"
                              onClick={() => handlePreSelectForm()}
                              variant="outlined"
                              color="black"
                              style={{ padding: 0, paddingLeft: 10, paddingRight: 10, height: 34, textTransform: 'none' }}
                              disabled={!fullVersion}
                            >
                              {/* <PlusIcon className={classes.plusSvg} /> */}
                              <Typography fontSize={30} style={{ marginBottom: 5 }} color="#404349">
                                +
                              </Typography>
                              <Typography ml={1} color="#404349">
                                {t('mygoal.label.add')}
                              </Typography>
                            </Button>
                          </Grid>
                        }
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    <Grid container lg={12} xs={12} mb={3} ml={1} sx={{ marginRight: '10px' }}>
                      {goalDetail.achievement?.length > 0
                        ?
                        goalDetail.achievement?.map((item, key) => {
                          return (
                            <Grid container mt="20px">
                              <Grid item xs={12}>
                                <Paper elevation={2}>
                                  <Grid container item p={2} display="flex" alignItems="center">
                                    <Grid item md={10} pr={1}>
                                      <Grid container item p={0}>
                                        <Grid item pr={1}>
                                          <BootstrapTooltip
                                            placement="right"
                                            arrow
                                            title={item.name}
                                          >
                                            <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349"
                                              sx={{
                                                display: '-webkit-box',
                                                overflow: 'hidden',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2
                                              }}
                                            >
                                              {item.name}
                                            </Typography>
                                          </BootstrapTooltip>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      display="flex"
                                      alignItems="center"
                                      flexDirection="row-reverse"
                                      md
                                    >
                                      <Box ml={1} p={0} className="clickable" onClick={() => handleGoTo(item.serial)}>
                                        <BootstrapTooltip title={t('label.viewDetail')} placement="top">
                                          <KpiArrow style={{ cursor: "pointer" }} />
                                        </BootstrapTooltip>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            </Grid>
                          )
                        })
                        :
                        <Grid item lg={12} xs={12} style={{ textAlign: 'center', marginTop: '50px' }}>
                          <Box>
                            <img src={fileBrowser} alt="browser" />
                          </Box>
                          <Box>
                            <Typography variant="sub_label">{t("mygoal.label.noData")}</Typography>
                          </Box>
                        </Grid>
                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Card style={{ minHeight: '420px', height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                        pb={isOwner ? '7px' : '0px'}
                      >
                        <Grid md={9} item style={{ height: '30px', marginBottom: '4px', paddingTop: '7px' }}>
                          <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                            {t('mygoal.label.goalMember')}
                          </Typography>
                        </Grid>
                        <Grid md={3} item textAlign="right">
                          <Typography onClick={() => openMemberDialog(true)} fontSize={14} lineHeight="21px" fontWeight="400" variant="label" color="#5DA196" textAlign="right" style={{ cursor: 'pointer' }}>
                            {t('mygoal.label.moreDetail')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    <Grid container lg={12} xs={12} mb={3} ml={1}>
                      <Grid item lg={5} xs={12} mb={2} mt={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.evaluatorType')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2} mt={2}>
                        <Grid container direction="row">
                          {goalDetail.goal_member?.evaluator?.fullname &&
                            <Grid item>
                              <Avatar
                                src={goalDetail.goal_member?.evaluator?.photo}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: '10px'
                                }}
                              >
                              </Avatar>
                            </Grid>
                          }
                          <Grid item>
                            <Typography fontWeight="400" fontSize={18} color="#939393">
                              {goalDetail.goal_member?.evaluator?.fullname || '-'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('label.owner')}
                        </Typography>
                      </Grid>
                      <Grid item lg={7} xs={12} mb={2}>
                        <Grid container direction="row">
                          {goalDetail.goal_member?.owner?.fullname &&
                            <Grid item>
                              <Avatar
                                src={goalDetail.goal_member?.owner?.photo}
                                sx={{
                                  width: 30,
                                  height: 30,
                                  marginRight: '10px'
                                }}
                              >
                              </Avatar>
                            </Grid>
                          }
                          <Grid item>
                            <Typography fontWeight="400" fontSize={18} color="#939393">
                              {goalDetail?.goal_member?.type?.toLowerCase() === "corporate goal" && !goalDetail?.goal_member?.owner ? i18n.language === "th-TH" ? "ผู้ดูแลระบบ" : "Admin" : goalDetail.goal_member?.owner?.fullname || '-'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={5} xs={12} mb={2}>
                        <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#404349">
                          {t('mygoal.label.goalMemberList')}
                        </Typography>
                      </Grid>
                      {goalDetail.goal_member?.members?.map((member, key) => {
                        return (
                          <>
                            {key > 0 &&
                              <Grid item lg={5} xs={12} mb={2}></Grid>
                            }
                            <Grid item lg={7} xs={12} mb={2} key={key}>
                              <Grid container direction="row">
                                <Grid item>
                                  <Avatar
                                    src={member?.photo}
                                    sx={{
                                      width: 30,
                                      height: 30,
                                      marginRight: '10px'
                                    }}
                                  >
                                  </Avatar>
                                </Grid>
                                <Grid item>
                                  <Typography fontWeight="400" fontSize={18} color="#939393">
                                    {member?.fullname}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )
                      })}
                      {goalDetail.goal_member?.members?.length === 0 &&
                        <Typography fontWeight="400" fontSize={18}>
                          -
                        </Typography>
                      }
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Card style={{ minHeight: '420px', height: '100%' }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Grid item lg={10} style={{ height: '30px' }} mt="7px" mb="7px">
                          <Typography lineHeight="21px" fontSize={20} fontWeight="500" color="#404349">
                            {t('mygoal.label.attach')} ({goalDetail.goal_file?.length})
                          </Typography>
                        </Grid>
                        {(isOwner || isMember) &&
                          <Grid item lg={2} textAlign="right" pb={'7px'}>
                            <Button
                              size="small"
                              aria-controls="simple-menu"
                              aria-haspopup="true"
                              onClick={() => handleFilesDialog(true)}
                              variant="outlined"
                              color="black"
                              style={{ padding: 0, paddingLeft: 10, paddingRight: 10, height: 34, textTransform: 'none' }}
                              disabled={!fullVersion}
                            >
                              <Typography fontSize={30} style={{ marginBottom: 5 }}>
                                +
                              </Typography>
                              <Typography ml={1}>
                                {t('mygoal.label.add')}
                              </Typography>
                            </Button>
                          </Grid>
                        }
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 4, marginBottom: 10 }} />
                    <Grid container lg={12} xs={12} mb={3} ml={1}>
                      <Grid item lg={12} xs={12} mb={2} mt={2} pr={'10px'}>
                        {
                          goalDetail?.goal_file !== undefined && goalDetail?.goal_file.length > 0 ?
                            [...(goalDetail?.goal_file)].map((item, index) => {
                              return <React.Fragment key={index}>
                                <Grid container mt={1} >
                                  <Grid item xs={12}>
                                    <Paper elevation={2}>
                                      <Grid container item p={2}>
                                        <Grid
                                          item
                                          display="flex"
                                          alignItems="center"
                                          md={1}
                                        >
                                          <Box ml={1} p={0} sx={{ width: "33px", height: "33px" }}>
                                            {item.mime_type === "application/pdf" ?
                                              <PdfIcon /> :
                                              item.mime_type === "image/png" ?
                                                <PngIcon /> :
                                                item.mime_type === "image/jpeg" ?
                                                  <JpgIcon /> : <NullIcon />
                                            }
                                          </Box>
                                        </Grid>
                                        <Grid item md={6} pr={1} onClick={() => openFileInNewTab(item)}>
                                          <Grid container item p={0}>
                                            <Grid item pr={1}>
                                              <BootstrapTooltip
                                                placement="right"
                                                arrow
                                                title={item.name}
                                              >
                                                <Typography fontSize={16} lineHeight="21px" fontWeight="400" color="#404349"
                                                  sx={{
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 2
                                                  }}
                                                >
                                                  {item.name}
                                                </Typography>
                                              </BootstrapTooltip>
                                            </Grid>
                                          </Grid>
                                          <Grid container item p={0}>
                                            <Grid item pr={1}>
                                              <Typography variant="sub_label">
                                                {niceBytes(item.size)}
                                              </Typography>
                                              <Typography variant="sub_label" pl={1} pr={1}>
                                                |
                                              </Typography>
                                              <Typography variant="sub_label">
                                                {Util.dateDayTimeFormat(item.created_at)}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        {/* {detailData?.isOwner ? */}
                                        <Grid
                                          item
                                          display="flex"
                                          alignItems="center"
                                          flexDirection="row-reverse"
                                          md
                                        >
                                          <Box ml={1} p={0} className="clickable" onClick={() => handleConfirmDeleteFileDialog(true, item.serial)}>
                                            <TrashIcon />
                                          </Box>
                                        </Grid>
                                        {/* : null
                                        } */}
                                      </Grid>
                                    </Paper>
                                  </Grid>
                                </Grid>
                              </React.Fragment>
                            }
                            ) :
                            true ?
                              (<Grid container spacing={4} mt={6}>
                                <Grid item lg={12} md={12}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDirection="column"
                                    p={1}
                                  >
                                    <Box>
                                      <img src={fileBrowser} alt="browser" />
                                    </Box>
                                    <Box>
                                      <Typography variant="sub_label">{t("label.noData")}</Typography>
                                    </Box>
                                  </Box>
                                </Grid>
                              </Grid>)
                              :
                              (<Grid container spacing={4} mt={6}>
                                <Grid item lg={12} md={12}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDirection="column"
                                    p={1}
                                  >
                                    <Box>
                                      <img src={fileBrowser} alt="browser" />
                                    </Box>
                                    <Box>
                                      <Typography variant="sub_label">{t("portfolio.label.nodata")}</Typography>
                                    </Box>
                                  </Box>
                                </Grid>
                              </Grid>)
                        }
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            :
            <Grid container spacing={2} mt={0}>
              <Grid item lg={12} md={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  p={1}
                  sx={{ minHeight: "400px" }}
                >
                  <Box>
                    <img src={fileBrowser} alt="browser" />
                  </Box>
                  <Box>
                    <Typography variant="sub_label">{t('competency.nodata')}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          }
          <Dialog open={isMemberDialogOpen} onBackdropClick={handleCloseDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row" style={{ justifyContent: 'space-between' }}>
                <Grid item>
                  <Typography fontSize={20} fontWeight={600} color="#404349">
                    {t('mygoal.label.moreDetail')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Icon style={{ color: '#000000', fontSize: 20, float: 'right', cursor: 'pointer' }} onClick={handleCloseDialog}>close</Icon>
                </Grid>
              </Grid>
              <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
              <Grid container>
                <Grid item lg={12}>
                  <Typography fontSize={14} color="#939393">
                    {t('mygoal.label.totalMember')} {totalMember(goalDetail)} {t('mygoal.label.member')}
                  </Typography>
                </Grid>
                {/* {goalDetail.goal_member?.evaluator != null &&
                  <Grid item lg={12} mt={2}>
                    <Grid container direction="row" style={{ alignItems: 'center' }}>
                      <Grid lg={1} item>
                        <Avatar
                          src={goalDetail.goal_member?.evaluator?.photo}
                          sx={{
                            width: 30,
                            height: 30,
                            marginRight: '10px'
                          }}
                        >
                        </Avatar>
                      </Grid>
                      <Grid lg={8} item>
                        <Typography fontSize={16} color="#404349">
                          {goalDetail.goal_member?.evaluator?.fullname}
                        </Typography>
                        <Typography fontSize={14} fontWeight={400} color="#939393">
                          {goalDetail.goal_member?.evaluator?.position}
                        </Typography>
                      </Grid>
                      <Grid lg={3} item>
                        <Typography fontSize={14} fontWeight={400} color="#939393" textAlign='right'>
                          {t('mygoal.label.evaluatorType')}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                } */}
                {goalDetail.goal_member?.owner != null &&
                  <Grid item lg={12} mt={2}>
                    <Grid container direction="row" style={{ alignItems: 'center' }}>
                      <Grid lg={1} item>
                        <Avatar
                          src={goalDetail.goal_member?.owner?.photo}
                          sx={{
                            width: 30,
                            height: 30,
                            marginRight: '10px'
                          }}
                        >
                        </Avatar>
                      </Grid>
                      <Grid lg={8} item>
                        <Typography fontSize={16} color="#404349">
                          {goalDetail.goal_member?.owner?.fullname}
                        </Typography>
                        <Typography fontSize={14} fontWeight={400} color="#939393">
                          {goalDetail.goal_member?.owner?.position}
                        </Typography>
                      </Grid>
                      <Grid lg={3} item>
                        <Typography fontSize={14} fontWeight={400} color="#939393" textAlign='right'>
                          {t('label.owner')}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                }
                {goalDetail.goal_member?.members?.map((member, key) => {
                  return (
                    <Grid item lg={12} xs={12} mt={2} key={key}>
                      <Grid container direction="row" style={{ alignItems: 'center' }}>
                        <Grid lg={1} item>
                          <Avatar
                            src={member?.photo}
                            sx={{
                              width: 30,
                              height: 30,
                              marginRight: '10px'
                            }}
                          >
                          </Avatar>
                        </Grid>
                        <Grid lg={8} item>
                          <Typography fontSize={16} color="#404349">
                            {member?.fullname}
                          </Typography>
                          <Typography fontSize={14} fontWeight={400} color="#939393">
                            {member?.position}
                          </Typography>
                        </Grid>
                        <Grid lg={3} item>
                          <Typography fontSize={14} fontWeight={400} color="#939393" textAlign='right'>
                            {t('label.member')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog open={isAlignmentOpen} onBackdropClick={handleCloseDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row" style={{ justifyContent: 'space-between' }}>
                <Grid item>
                  <Typography fontSize={20} fontWeight={600} color="#404349">
                    {t('mygoal.label.moreDetail')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Icon style={{ color: '#000000', fontSize: 20, float: 'right', cursor: 'pointer' }} onClick={handleCloseDialog}>close</Icon>
                </Grid>
              </Grid>
              <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
              <Grid container>
                <Grid item lg={12}>
                  <Typography fontSize={14} color="#939393">
                    {t('mygoal.label.totalMember')} {totalAlignment(goalDetail)} {t('mygoal.label.member')}
                  </Typography>
                </Grid>
                {goalDetail.goal_alignment?.members?.map((member, key) => {
                  return (
                    <Grid item lg={12} xs={12} mt={2} key={key}>
                      <Grid container direction="row" style={{ alignItems: 'center' }}>
                        <Grid lg={1} item>
                          <Avatar
                            src={member?.photo}
                            sx={{
                              width: 30,
                              height: 30,
                              marginRight: '10px'
                            }}
                          >
                          </Avatar>
                        </Grid>
                        <Grid lg={8} item>
                          <Typography fontSize={16} color="#404349">
                            {member?.fullname}
                          </Typography>
                          <Typography fontSize={14} fontWeight={400} color="#939393">
                            {member?.position}
                          </Typography>
                        </Grid>
                        {/* <Grid lg={3} item>
                          <Typography fontSize={14} fontWeight={400} color="#939393" textAlign='right'>
                            {t('label.member')}
                          </Typography>
                        </Grid> */}
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row">
                <Grid item lg={11}>
                  <Typography fontSize={24} fontWeight="600" color="#404349">
                    {t('mygoal.label.updateGoal')}
                  </Typography>
                </Grid>
                <Grid item lg={1} style={{ textAlign: 'right' }}>
                  <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                    X
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ paddingTop: "20px" }} />
              <Grid container>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalToUpdate')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="primary">
                    {goalDetail.goal?.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalMetric')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {goalDetail.goal_progress?.goal_metric.description}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.targetValue')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {Util.upperFirstWord(targetCondition ?? '')} {goalDetail.goal_progress?.target_value} {goalDetail.goal_progress?.unit && goalDetail.goal_progress?.unit !== "-" ? goalDetail.goal_progress?.unit : ""}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.resultAsOf')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      format="dd/MM/yyyy"
                      value={asOfDate}
                      onChange={(newValue) => {
                        if (newValue) {
                          setAsOfDate(Util.formatDate(newValue));
                        } else {
                          setAsOfDate(null)
                        }
                      }}
                      style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                      inputProps={{
                        placeholder: "As of date", sx: {
                          "&::placeholder": {
                            color: "#AAAAAA"
                          },
                          "&borderColor": {
                            color: '#CED4DA'
                          },
                          "color": '#404349'
                        }
                      }}
                      renderInput={(params) => <TextField {...params}
                        fullWidth
                        size="small"
                        style={{ color: '#404349' }}
                      />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.actualValue')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                    ?
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container direction="row">
                        <Grid item lg={10}>
                          <DesktopDatePicker
                            format="dd/MM/yyyy"
                            value={targetValue}
                            onChange={(newValue) => {
                              if (newValue) {
                                setTargetValue(Util.formatDate(newValue));
                              } else {
                                setTargetValue(null)
                              }
                            }}
                            style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                            inputProps={{
                              placeholder: "Current Value", sx: {
                                "&::placeholder": {
                                  color: "#AAAAAA"
                                },
                                "&borderColor": {
                                  color: '#CED4DA'
                                },
                                "color": '#404349'
                              }
                            }}
                            renderInput={(params) => <TextField {...params}
                              fullWidth
                              size="small"
                              style={{ color: '#404349' }}
                            />}
                          />
                        </Grid>
                        <Grid item>
                          <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                    :
                    (!goalDetail?.goal_progress?.goal_metric?.options)
                      ?
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          value={targetValue}
                          onChange={(val) => { setTargetValue(val.target.value) }}
                          renderValue={(selected) => {
                            if (selected === null || selected === "") {
                              return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>;
                            } else {
                              return <Typography color="#404349">{selected}</Typography>
                            }
                          }}
                          endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                        >
                          <MenuItem value={""}>
                            <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                          </MenuItem>
                          <MenuItem value={"Success"}>Success</MenuItem>
                          <MenuItem value={"Fail"}>Fail</MenuItem>
                        </Select>
                      </FormControl>
                      :
                      <TextField
                        autoComplete='off'
                        style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                        InputProps={{
                          endAdornment: targetValue ? (
                            <IconButton onClick={handleClearClick}>
                              <ClearIcon />
                            </IconButton>
                          ) : undefined
                        }}
                      />

                  }
                  {
                    scaleLevelCurrent &&
                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase", mt: 1 }}>
                      {scaleLevelCurrent}
                    </Typography>
                  }
                </Grid>
                {/* <Grid item lg={2}></Grid> */}
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('mygoal.label.goalProgress')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      value={progressValue}
                      onChange={(val) => { setProgressValue(val.target.value) }}
                      sx={{ color: "#404349" }}
                      renderValue={(selected) => {
                        if (selected === null) {
                          return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>;
                        } else {
                          return goalProgressOption?.find((item) => item.serial === selected)?.name
                          // Mockup Because api is not working
                        }
                      }}
                    >
                      <MenuItem disabled value={null}>
                        <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                      </MenuItem>
                      {goalProgressOption?.map((item, key) => {
                        return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.remark')}:
                  </Typography>
                </Grid>
                <Grid item lg={12} pt={'7px'}>
                  <TextField
                    autoComplete='off'
                    multiline
                    rows={2}
                    maxRows={4}
                    style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Box classes="mt-3">
                <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
                  {t('mygoal.label.cancel')}
                </Button>
                <Button onClick={() => updateGoal()} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                  <Typography>
                    {t('mygoal.label.justUpdate')}
                  </Typography>
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
          <Dialog open={isScaleDialogOpen} onBackdropClick={handleCloseDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row" style={{ justifyContent: 'space-between' }}>
                <Grid item>
                  <Typography fontSize={22} fontWeight={600} color="#404349">
                    {t('mygoal.label.scaleLevel')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Icon style={{ color: '#000000', fontSize: 20, float: 'right', cursor: 'pointer' }} onClick={handleCloseDialog}>close</Icon>
                </Grid>
              </Grid>
              <Grid item>
                <Typography fontSize={16} fontWeight={400} color="#404349">
                  {t('mygoal.label.scaleLevelDesc')}
                </Typography>
              </Grid>
              <Grid container>
                <Grid ml={1} container spacing={2} style={{ border: '1px solid #DADADA', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '13px', borderRadius: '10px' }} mt={3}>
                  <Grid md={2} item textAlign="center">
                    <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                      {t("mygoal.label.level")}
                    </Typography>
                  </Grid>
                  <Grid md={2} item></Grid>
                  <Grid md={3} item textAlign="center">
                    <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                      {t("mygoal.label.actualMin")}
                    </Typography>
                  </Grid>
                  <Grid md={1} item></Grid>
                  <Grid md={3} item textAlign="center">
                    <Typography variant="label" fontSize={16} fontWeight={400} color={'#A0A0A0'}>
                      {t("mygoal.label.actualMax")}
                    </Typography>
                  </Grid>

                  {goalScaleData.map((scale, idx) => {
                    return (
                      <Grid container key={idx}>
                        <Grid md={12} item mt={1.5} mb={1.5}>
                          <Divider />
                        </Grid>
                        <Grid md={2} item textAlign="center">
                          <Typography variant="label" style={{ fontWeight: 400, fontSize: '18px', color: '#404349' }}>
                            {scale.level ?? (idx + 1)}
                          </Typography>
                        </Grid>
                        <Grid md={2} item></Grid>
                        <Grid md={3} item>
                          <Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }} textAlign="center">{scale.value_min}</Typography>
                        </Grid>
                        <Grid md={1} item></Grid>
                        <Grid md={3} item>
                          <Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }} textAlign="center">{scale.value_max}</Typography>
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          {/* success & confirm dialog */}
          <Dialog
            onBackdropClick={backdropClick}
            disableEscapeKeyDown
            open={isAddDialogOpen}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth="lg"
            PaperProps={{ sx: { padding: "10px" } }}
          >
            <DialogTitle id="form-add-dialog-title" fontSize={24} color="#404349">
              {t("achievement.label.addNewAchievement")}
            </DialogTitle>
            <DialogContent px={0} pb={0}>
              <Divider />
              <InputForm
                close={handleCloseDialogAlertDialog}
                edit={handleSubmitForm}
                data={formData}
                type={formType}
                form={attachCycle}
              ></InputForm>
            </DialogContent>
          </Dialog>
          <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title={t('mygoal.popup.submitApprove')} text={t('mygoal.popup.submitApproveDesc')} />
          <SimpleDialog open={isSuccessDialogOpen} setValue={openConfirmDialog} text={t('mygoal.popup.addGoalSuccess')} />
          <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={`${t("mygoal.label.confirmDelete")}`} text={`${t("mygoal.label.confirmDeleteDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />
          <ConfirmDialog open={isCancelDeleteDialogOpen} trash={true} doConfirm={handleCancelDeleteList} setValue={handleCancelDeleteDialog} title={`${t("mygoal.label.cancelDelete")}`} text={`${t("mygoal.label.cancelDeleteDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />
          <AlertDialog
            open={isAlertDialogOpen}
            title={title}
            message={message}
            type={typeAlertDialog}
            color={color}
            close={onCloseAlertDialog}
            acceptConfirm=""
            colorHover={colorHover}
            size={size}
          />
          <SimpleDialog
            open={isSuccessDialogAlertDialog}
            setValue={setSuccessDialogAlertDialog}
            text={t("achievement.label.dialog.addAchievement")}
          />
          <MessageDialog
            open={openFailedMessageDialogAlertDialog}
            setValue={handleCloseFailedMessageDialogAlertDialog}
            type="fail"
            title={t("achievement.label.dialog.failed")}
            text={errorText + t("achievement.label.dialog.again")}
          />

          <HistoryDialog open={openHistoryDialog} setValue={setHistoryDialog} data={historyData} serial={serial} isOwner={isOwner} optionalData={historyOptionalData} doCallback={() => doGetMyGoalDetail()} />
          <SimpleDialog page={true} open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} doDirect={() => goto('mygoal', state)} title={t('mygoal.popup.success')} text={t('mygoal.popup.deleteGoalSuccess')} />
          <SimpleDialog open={isSuccessAddDialogOpen} setValue={openSuccessAddDialog} text={t('mygoal.popup.update')} title="Success" />
          <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title={t('mygoal.popup.fail')} text={errorText + ` \n${t('mygoal.popup.again')}`} />
          <ConfirmDialog open={discardDialogAlertDialog} warning={true} doConfirm={() => handleDiscardChangeConfirmAlertDialog()} setValue={() => handleDiscardDialog(false)} title={t("achievement.label.dialog.discardTitle")} text={t("achievement.label.dialog.discardText")} />
          <AttachFilesDialog open={isAttachFilesDialogOpen} setValue={openAttachFilesDialog} submitFiles={() => uploadAttachmentsSuccess()} value={fileList}></AttachFilesDialog>
          <MessageDialog open={isSuccessAttachFiles} setValue={() => setIsSuccessAttachFiles(false)} title={t("label.success_simple")} text={successAttachmentsText} />
          <ConfirmDialog open={isConfirmDeleteFileDialogOpen} doConfirm={handleConfirmDeleteAchievementFile} trash={true} setValue={handleConfirmDeleteFileDialog} title={t("achievement.label.dialog.confirmDeleteAttachmentTitle")} text={t("achievement.label.dialog.confirmDeleteAttachmentText")} />
          <SimpleDialog open={isSuccessDeleteFileDialogOpen} setValue={handleSuccessDeleteFileDialog} text={t("achievement.label.dialog.deleteAttachment")} />
          <SimpleDialog open={isSuccessCancelDeleteDialogOpen} setValue={openSuccessCancelDeleteDialog} title={t('mygoal.popup.successCancel')} text={t('mygoal.popup.successCancelDesc')} />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalDetail;
